import api from '../../../api/api'
import { _orderByName } from '../../../utils/formatter'

export default {
  list: async (active = null, resumo = false) => {
    const data = await api.get.produtores(active, resumo)

    return _orderByName({
      data,
      key: 'name',
    })
  },
}
